module.exports = __webpack_public_path__ + "static/media/lascalles01_medium.cd145132.jpg";